var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticStyle: { "margin-top": "15px" } },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c(
              "div",
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading",
                      },
                    ],
                    staticStyle: { width: "100%" },
                    attrs: {
                      id: "analyticsTable",
                      data: _vm.rows,
                      border: "",
                      fit: true,
                      stripe: "",
                      "max-height": 800,
                      "show-summary": false,
                      "highlight-current-row": "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "Location",
                        "min-width": "180",
                        "column-key": "Location",
                        prop: "Location",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Client Name",
                        "min-width": "180",
                        "column-key": "Client Name",
                        prop: "Client Name",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Phone Number",
                        "min-width": "180",
                        "column-key": "Phone Number",
                        prop: "Phone Number",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Attorney",
                        "min-width": "180",
                        "column-key": "Attorney",
                        prop: "Attorney",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Result",
                        "min-width": "180",
                        "column-key": "Result Type",
                        prop: "Result Type",
                        "header-align": "center",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }